import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import { supabase } from '../../lib/supabase'
import Loader from '../../components/Loader'
import '../onboarding/onboarding.css'
import './settings.css'

const NETLIFY_FUNCTIONS = import.meta.env.VITE_NETLIFY_FUNCTIONS_URL || ''

const SettingsSubscriptions = () => {
  const navigate = useNavigate()
  const { profile, user, refreshProfile } = useAuth()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  // Обновляем профиль при монтировании компонента (особенно важно после возврата из Stripe)
  useEffect(() => {
    if (user) {
      refreshProfile()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Вызываем только при монтировании компонента

  // Также обновляем профиль когда страница становится видимой (возврат из Stripe)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && user) {
        refreshProfile()
      }
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user])

  // Проверяем наличие активной подписки
  // Показываем "Manage" если:
  // 1. subscription_status === 'active' или 'trial' (активная подписка)
  // 2. stripe_customer_id существует (даже если подписка отменена, но еще активна до конца периода)
  const hasSubscription = 
    profile?.subscription_status === 'active' || 
    profile?.subscription_status === 'trial' ||
    !!profile?.stripe_customer_id

  const onBack = () => navigate('/app/profile/settings')
  const onActivate = () => navigate('/paywall?reason=subscription', { state: { from: '/app/profile/settings/subscriptions' } })

  const onManageSubscription = async () => {
    setError('')
    setLoading(true)
    try {
      const { data: { session } } = await supabase.auth.getSession()
      const token = session?.access_token
      const url = NETLIFY_FUNCTIONS ? `${NETLIFY_FUNCTIONS}/create-billing-portal-session` : '/.netlify/functions/create-billing-portal-session'
      const res = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
      })
      const data = await res.json().catch(() => ({}))
      if (!res.ok) {
        setError(data.error || 'Something went wrong')
        setLoading(false)
        return
      }
      if (data.url) {
        window.location.href = data.url
        return
      }
      setError('Could not open billing portal')
    } catch (e) {
      console.error(e)
      setError('Failed to open billing portal')
    }
    setLoading(false)
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content" style={{ paddingTop: 48, paddingBottom: 80 }}>
        <div style={{ marginBottom: 24 }}>
          <button type="button" className="link" onClick={onBack}>← Back</button>
        </div>
        <h1 className="h1">Subscriptions</h1>
        <p className="p" style={{ marginBottom: 16 }}>AstroPlus — manage your subscription.</p>
        {error && <p className="p" style={{ color: 'var(--error)', marginBottom: 16 }}>{error}</p>}
        {hasSubscription ? (
          <button
            type="button"
            className="settings-modal-btn settings-modal-btn-primary"
            onClick={onManageSubscription}
            disabled={loading}
          >
            {loading ? <Loader text="Opening..." inline /> : 'Manage subscription'}
          </button>
        ) : (
          <button type="button" className="settings-modal-btn settings-modal-btn-primary" onClick={onActivate}>Activate</button>
        )}
      </div>
    </div>
  )
}

export default SettingsSubscriptions
